import { t as toString$1 } from './to-string.js';

var toString = toString$1;

var normalizeStringArgument = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};

export { normalizeStringArgument as n };
